// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"64":"33c488e7","175":"21656e28","308":"82b7fb62","337":"17637040","351":"21656e28","667":"762da17e","765":"21656e28","887":"beeb0a32","978":"28d5ba6d"}[chunkId] + ".css";
};